import { Markdown } from 'tiptap-markdown';

import { extensions } from '@eluve/tiptap-extensions';

import { ClipboardExtension } from './clipboard';
import CustomKeymap from './custom-keymap';
import { Footnote } from './footnotes';
import { SlashCommandExtension } from './slash-command';

export const defaultExtensions = [
  ...extensions,
  SlashCommandExtension,
  CustomKeymap,
  Footnote,
  Markdown.configure({
    html: true,
    transformCopiedText: false,
    transformPastedText: true,
  }),
  ClipboardExtension,
];
